module.exports = __webpack_public_path__ + "img/advantage-4.9ae20d86.png";